<template>
  <div class="main">
    <div class="title">捐献流程</div>

    <div class="content">
      <div class="fr jc ac">在上海市</div>

      <div class="fr jc ac mt6">一共有 <span class="red-text">两所</span>   采集医院</div>

      <div class="fr jc ac mt6">分别是</div>

      <div class="fr jc ac mt6 bold">上海市第一人民医院</div>

      <div class="fr jc ac mt6">
        <img src="../../assets/jxlc/shsdyrmyy.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40 bold">华山医院</div>

      <div class="fr jc ac mt10">
        <img src="../../assets/jxlc/hsyy.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40">采集是需要提前入院的</div>

      <div class="fr jc ac mt6">在入院的   <span class="red-text">第一天</span></div>

      <div class="fr jc ac mt6">市红会的工作人员会帮你办理好入库手续</div>

      <div class="fr jc ac mt6">入院期间的日用品也会为你准备好</div>

      <div class="fr jc ac mt6">你只需带好替换衣物和个人用品</div>

      <div class="fr jc ac mt6">一切妥当后入住我们漂亮的病房</div>
      <div class="fr jc ac mt20">
        <img src="../../assets/jxlc/病房.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40">护士会为你测量体温和血压</div>
      <div class="fr jc ac mt6">抽取血常规</div>
      <div class="fr jc ac mt6">同时将会花费5分钟</div>

      <div class="fr jc ac mt6">给你注射第一针集落刺激因子(俗称<span class="red-text">动员剂</span>)</div>

      <div class="fr jc ac mt6">然后进行B超检查</div>

      <div class="fr jc ac mt6">在接下来的 <span class="red-text"> 第二、三、四天里</span></div>

      <div class="fr jc ac mt6">每天都会抽取血常规</div>

      <div class="fr jc ac mt6">每天都会注射动员剂</div>

      <div class="fr jc ac mt20">
        <img src="../../assets/jxlc/注射.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40">入院的 <span class="red-text">第五天</span> </div>

      <div class="fr jc ac mt6">也就是捐献采集的当天</div>
      <div class="fr jc ac mt6">最后一次注射动员剂</div>

      <div class="fr jc ac mt6">进行光荣的表彰仪式</div>
      <div class="fr jc ac mt6">一箩筐的荣誉</div>

      <div class="fr jc ac mt20">
        <img src="../../assets/jxlc/荣誉证书1.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt20">
        <img src="../../assets/jxlc/荣誉证书2.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40">在工作人员和医务人员的陪同下</div>
      <div class="fr jc ac mt6">造血干细胞采集正式开始</div>
      <div class="fr jc ac mt6">你只需要做一件事</div>
      <div class="fr jc ac mt6">躺躺躺...</div>

      <div class="fr jc ac mt6">这个小编我也不懂的高科技</div>
      <div class="fr jc ac mt6">就是采集机器</div>
      <div class="fr jc ac mt20">
        <img src="../../assets/jxlc/采集机器.png" class="hospital-img" alt />
      </div>

      <div class="fr jc ac mt40"> <span class="red-text"> 3~4小时 </span> 左右后</div>
      <div class="fr jc ac mt6">将采集出100~150毫升造血干细胞</div>
      <div class="fr jc ac mt6">医院会对采集的造血干细胞计数</div>

      <div class="fr jc ac mt6">如果计数不到标准</div>
      <div class="fr jc ac mt6">第二天仍需要继续采集</div>
      <div class="fr jc ac mt6">而且采集前</div>
      <div class="fr jc ac mt6">还需要打一针动员剂</div>
      <div class="fr jc ac mt6">计数达标后</div>
      <div class="fr jc ac mt6">上海市分库专职工作人员</div>
      <div class="fr jc ac mt6">与患者医院进行造血干细胞交接</div>
      <div class="fr jc ac mt6">医生检查你的身体情况后</div>
      <div class="fr jc ac mt6">观察一段时间</div>
      <div class="fr jc ac mt6">就可以 <span class="red-text">出院啦</span> </div>
      <div class="fr jc ac mt6">在采集后的两周里</div>
      <div class="fr jc ac mt6">每一周都会进行一次血液检查</div>
      <div class="fr jc ac mt6">第四周再次进行血液检查</div>
      <div class="fr jc ac mt6">半年内还会进行一次 <span class="red-text">体检</span></div>
      <div class="fr jc ac mt6">好啦，这就是整个采集捐献的过程</div>

      <div class="fr jc ac mt40">
        <img src="../../assets/jxlc/二维码.png" style="width:108px;height:108px" alt />
      </div>

      <div class="fr jc ac mt20" style="color:#bb1b21">捐献造血干细胞,微信报名更方便</div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  font-size: 12px;

  background-image: url("../../assets/jxlc/bg.png");
  background-size: cover;
  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    font-size: 14px;
    margin-top: 16px;

    padding: 25px;
    background-color: #fef2f4;
    border-radius: 10px;
  }

  .hospital-img {
    width: 183px;
    height: 143px;
  }

  .red-text {
    font-size: 18px;
    color: #bb1b21;
  }
}
</style>